import {
  Chart,
  ArcElement,
  BarElement,
  BarController,
  DoughnutController,
  // LineElement,
  // PointElement,
  // BubbleController,
  // LineController,
  // PieController,
  // PolarAreaController,
  // RadarController,
  // ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Legend,
  Title,
  Tooltip,
  SubTitle
} from 'chart.js';

export default class ChartPlugin {
  static register() {
    Chart.register(
      // Elements
      BarElement,
      ArcElement,
    
      // Controllers
      BarController,
      DoughnutController,
    
      // Scales
      CategoryScale,
      LinearScale,
      LogarithmicScale,
      RadialLinearScale,
      TimeScale,
      TimeSeriesScale,
    
      // Other Stuff
      Decimation,
      Filler,
      Legend,
      Title,
      Tooltip,
      SubTitle
    )
  }
}